import { trackFirebaseScreenView } from "./analytics";
import { FIREBASE_SCREEN_ID, type FirebaseScreenId } from "./types";

/**
 * ルート pathname → 画面ID の対応。
 * 画面ID一覧（依頼書 §4 + 修正）に無い画面は screen_view を送らない。
 * Sina に存在しない画面（find/ranking/call_history/waiting 等）は割り当て無しでOK。
 */
const EXACT_PATH_TO_SCREEN_ID: Record<string, FirebaseScreenId> = {
  "/discover": FIREBASE_SCREEN_ID.RECOMMEND,
  "/search": FIREBASE_SCREEN_ID.SEARCH,
  "/board": FIREBASE_SCREEN_ID.BOARD,
  "/my-page/footprint": FIREBASE_SCREEN_ID.FOOTSTEP,
  "/gallery": FIREBASE_SCREEN_ID.GALLERY,
  "/my-page/bookmarks": FIREBASE_SCREEN_ID.FAVORITE_LIST,
  "/setting/likes": FIREBASE_SCREEN_ID.LIKE_LIST,
  "/fleamarket": FIREBASE_SCREEN_ID.FLEAMARKET,
  "/my-page": FIREBASE_SCREEN_ID.PROFILE_SELF,
  "/purchase": FIREBASE_SCREEN_ID.PAYWALL,
};

/** 1対1チャット画面（/messages/<conversationId>） */
const CHAT_PATH_PATTERN = /^\/messages\/[^/]+$/;

const normalizePathname = (pathname: string): string => {
  return pathname.length > 1 && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;
};

/** pathname に対応する画面IDを返す。一覧に無い画面は null */
export const getFirebaseScreenIdForPath = (
  pathname: string,
): FirebaseScreenId | null => {
  const normalized = normalizePathname(pathname);
  const exact = EXACT_PATH_TO_SCREEN_ID[normalized];
  if (exact) return exact;
  if (CHAT_PATH_PATTERN.test(normalized)) return FIREBASE_SCREEN_ID.CHAT;
  return null;
};

let lastTrackedPathname: string | null = null;

/**
 * ルート遷移確定時に呼ぶ（main.tsx の router.subscribe から一括フック）。
 * search params のみの変化（同一 pathname）は画面遷移とみなさず送らない。
 */
export const trackFirebaseScreenViewForPath = (pathname: string): void => {
  const normalized = normalizePathname(pathname);
  if (normalized === lastTrackedPathname) return;
  lastTrackedPathname = normalized;

  const screenId = getFirebaseScreenIdForPath(normalized);
  if (!screenId) return;
  trackFirebaseScreenView(screenId);
};

/** テスト用: 直近の追跡 pathname をリセットする */
export const resetFirebaseScreenPathState = (): void => {
  lastTrackedPathname = null;
};
